// extracted by mini-css-extract-plugin
export default {"container":"Textarea_container__n41h3","content":"Textarea_content__v5r-2","textarea":"Textarea_textarea__Nla0q"};